// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__1uAx5","col":"Detail_col__fW1t3"};